import React from 'react';
import { i18n } from '@international/mastodon-i18n';

import { getRandomKey } from 'lib/helpers';
import { SearchRecord } from 'types/record';
import { Search } from 'types/search';
import { CandidateStoryHeader, TranslatedParagraph } from '../../../Common';
import ChargesByRecordForm from './ChargesByRecordForm';
import CandidateStoriesMultiSelect from './CandidateStoriesMultiSelect';

import { CANS_STEP_SELECT } from '../../../../../../../../../constants';

interface ChargesFormProps {
  searches: Search | Search[];
  selectedRecords: SearchRecord[];
  generalInfoEnabled: boolean;
  generalInformation: boolean;
  toggleGeneralInformation: () => void;
  toggleRecord: (value: SearchRecord) => void;
  companyName: string;
}

const ChargesForm = ({
  searches,
  toggleRecord,
  selectedRecords,
  generalInfoEnabled,
  generalInformation,
  toggleGeneralInformation,
  companyName,
}: ChargesFormProps) => {
  const renderSearches = () => {
    if (Array.isArray(searches)) {
      const considerSearches = searches.filter(
        search => search?.status === 'consider',
      );
      return considerSearches.map(search => (
        <ChargesByRecordForm
          key={getRandomKey()}
          search={search}
          toggleRecord={toggleRecord}
          selectedRecords={selectedRecords}
        />
      ));
    }
    return (
      searches?.status === 'consider' && (
        <ChargesByRecordForm
          search={searches}
          toggleRecord={toggleRecord}
          selectedRecords={selectedRecords}
        />
      )
    );
  };

  return (
    <div data-testid='charges-form'>
      <CandidateStoryHeader step={CANS_STEP_SELECT} />

      <TranslatedParagraph
        value='components.Report.CandidateStories.Modal.SelectRecord.introduction'
        interpolationValues={{ company: companyName }}
        className='mb-4'
      />

      {generalInfoEnabled && (
        <>
          <CandidateStoriesMultiSelect
            displayValue={i18n.getStr(
              'components.Report.CandidateStories.Modal.SelectRecord.generalInfo',
            )}
            selectValue
            toggleValue={toggleGeneralInformation}
            selected={generalInformation}
          />
          <hr />
        </>
      )}
      <div className='form-group' data-testid='record-selection'>
        {renderSearches()}
      </div>
    </div>
  );
};

export default i18n.renderTranslation()(ChargesForm);
